import { render } from "./VisualEditsPanel.vue?vue&type=template&id=319e4593&scoped=true"
import script from "./VisualEditsPanel.vue?vue&type=script&lang=js"
export * from "./VisualEditsPanel.vue?vue&type=script&lang=js"

import "./VisualEditsPanel.vue?vue&type=style&index=0&id=319e4593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319e4593"]])

export default __exports__